import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=5d43361f&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=ts&"
export * from "./FAQ.vue?vue&type=script&lang=ts&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=5d43361f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43361f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabItem,VTabs,VTabsItems})
